<template>
  <div class="qir-overview__wrapper full-width-section">
    <div class="qir-overview__container">
      <h2 class="qir-overview__title title">
        Why Choose the Quarterly Intelligence Reports?
      </h2>

      <p class="qir-overview__description text-body">
        The Quarterly Intelligence Reports offer valuable insights for
        professionals in the financial sector, highlighting essential market
        developments and trends to help guide informed decisions.
      </p>

      <title-description-list
        :items="$options.consts.LIST_ITEMS"
        class="qir-overview__list"
      >
        <template #title="{ title }">
          <span class="qir-overview__list-item-title text-body">
            {{ title }}
          </span>
        </template>

        <template #description="{ description }">
          <span class="qir-overview__list-item-description text-caption">
            {{ description }}
          </span>
        </template>
      </title-description-list>

      <div class="qir-overview__team-members-slider-wrapper">
        <qir-overview-slider
          :qir-gallery="qirGallery"
          class="qir-overview__team-members-slider"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QirOverviewSlider from 'sections/_qir/QirOverview/QirOverviewSlider/index.vue'
import TitleDescriptionList from 'sections/_shared/TitleDescriptionList/index.vue'

export default {
  name: 'QirOverview',
  components: { TitleDescriptionList, QirOverviewSlider },
  consts: {
    LIST_ITEMS: [
      {
        title: 'Regional Market Trends',
        description:
          'Discover the latest market movements and opportunities across key regions.'
      },
      {
        title: 'Industry Regulations',
        description:
          'Keep up with the latest regulatory changes and understand their effects on the financial markets.'
      },
      {
        title: 'Broker Performance & Rankings',
        description:
          'Stay updated on broker rankings and performance metrics, including trading volumes and profitability.'
      }
    ]
  },
  data() {
    return {
      qirGallery: [
        {
          Image: {
            URL: '/images/qir-gallery/2025q3-1.png',
            AltText: 'QIR 3 2025 What Brokerage Pays in Cyprus.'
          }
        },
        {
          Image: {
            URL: '/images/qir-gallery/2025q3-2.png',
            AltText:
              'QIR 3 2025 Section 2 Cryptocurrencies Relative Performance Benchmark.'
          }
        },
        {
          Image: {
            URL: '/images/qir-gallery/2025q3-3.png',
            AltText: '2025 QIR 3 Most Popular Trading Apps Downloads.'
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.qir-overview__wrapper {
  background-color: $c--gray-dark;
  position: relative;

  // to make sure background assets from previous section won't overlap
  z-index: 2;

  .qir-overview__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd 0,
      $desktop-md: 64px $padding-x-desktop-md 0,
      $mobile: 32px $padding-x-mobile 0
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .qir-overview__title {
    margin-bottom: 20px;
  }

  .qir-overview__description {
    color: $c--text-secondary;

    $margin-bottom: (
      $above-desktop-xl: 64px,
      $desktop-md: 32px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);

    @include mobile {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .qir-overview__list {
    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(3, minmax(0, 100%)),
        $mobile: minmax(0, 100%)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 64px
      ),
      $rowGapSetup: (
        $mobile: 24px
      )
    );

    @include gridBuilder($grid-setup);
  }

  .qir-overview__list-item-title {
    font-weight: 600;

    @include mobile {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .qir-overview__team-members-slider-wrapper {
    $margin: (
      $above-desktop-xl: 100px -#{$padding-x-desktop-full-hd} 0,
      $desktop-md: 64px -#{$padding-x-desktop-md} 0,
      $mobile: 32px -#{$padding-x-mobile} 0
    );

    @include setStyleByBreakpoint('margin', $margin);
  }
}
</style>
